export var LogMode;
(function (LogMode) {
    LogMode["Cached"] = "cached";
    LogMode["Standard"] = "standard";
})(LogMode || (LogMode = {}));
// Keys used with local storage to configure cached logging
var LogKeys;
(function (LogKeys) {
    LogKeys["Mode"] = "logMode";
    LogKeys["CacheSize"] = "logCacheSize";
})(LogKeys || (LogKeys = {}));
const defaultCacheSize = 25_000;
// Changing sizes requires a browser refresh
export function getLogSizes() {
    const cacheSize = +((globalThis.window !== undefined &&
        globalThis?.localStorage[LogKeys.CacheSize]) ||
        defaultCacheSize);
    return cacheSize;
}
export function isCachingAvailable() {
    // Must be in environment with IndexedDB on global window object
    return globalThis.window !== undefined && 'indexedDB' in globalThis;
}
export function getLoggingMode() {
    const isAvailable = isCachingAvailable();
    const savedMode = isAvailable && globalThis?.localStorage[LogKeys.Mode];
    const currentMode = !savedMode || !isAvailable ? LogMode.Standard : savedMode;
    return currentMode;
}
export function isCachingOn(enabledForUser) {
    const isAvailable = isCachingAvailable();
    const currentMode = getLoggingMode();
    const resolvedMode = isAvailable && enabledForUser ? currentMode : LogMode.Standard;
    // Ensure resolved mode matches saved mode
    if (isAvailable && currentMode !== resolvedMode) {
        globalThis?.localStorage?.setItem(LogKeys.Mode, resolvedMode);
    }
    return resolvedMode === LogMode.Cached;
}
export function toggleCaching() {
    if (!isCachingAvailable()) {
        return false;
    }
    const currentMode = getLoggingMode();
    const newMode = currentMode === LogMode.Standard ? LogMode.Cached : LogMode.Standard;
    globalThis?.localStorage?.setItem(LogKeys.Mode, newMode);
    return newMode === LogMode.Cached;
}
//# sourceMappingURL=predicates.js.map